import {map} from 'rxjs/operators';

import {Router} from '@angular/router';
import {Component, OnInit} from '@angular/core';
import {ApiServiceService} from '../api-service.service';
import {Keys, StorageService} from '../service/storage.service';
import {MatDialog} from '@angular/material';
import {VirtualAccountDescriptionPopUpComponent} from '../views/virtual-account-description-pop-up/virtual-account-description-pop-up.component';
import {HttpClient} from '@angular/common/http';

@Component({
    selector: 'app-lenderinitial',
    templateUrl: './lenderinitial.component.html',
    styleUrls: ['./lenderinitial.component.css'],
    providers: [ApiServiceService]
})
export class LenderinitialComponent implements OnInit {
    result2: any;
    name: string;
    city: string;
    photo: string;
    bankDetails = true;

    bank_name: string;
    branch_name: string;
    ifsc: string;
    bank_ifsc: string;
    lender_status: string;
    acc_no: string;
    re_acc_no: string;
    bank_list: any;
    lenderApplicationStatus: string;
    virtualAccountNumber: string;

    constructor(private http: HttpClient, private router: Router, private ref: ApiServiceService, private storageService: StorageService, private dialog: MatDialog) {
    }

    ngOnInit() {
        this.result2 = this.http.post<any>(this.ref.baseURL() + 'getLenderInfoDetails',
            {
                lender_id: this.storageService.getItem(Keys.LENDER_ID),
                profile_id: this.storageService.getItem(Keys.PROFILE_ID),
                token: this.storageService.getItem(Keys.TOKEN)
            }).subscribe((result2) => {
                this.result2 = result2;
                if (this.result2.status == 'success') {
                    this.virtualAccountNumber = this.result2.lender_info.virtual_account_id;
                    this.lenderApplicationStatus = this.result2.lender_info.lender_application_status;
                    this.name = this.result2.lender_info.profile.name;
                    if (this.result2.lender_info.document_upload.length > 0) {

                        for (let i = 0; i < this.result2.lender_info.document_upload.length; i++) {
                            if (this.result2.lender_info.document_upload[i].type == 'photo') {

                                this.photo = this.result2.lender_info.document_upload[i].source;
                            }
                        }
                    } else {

                        this.photo = 'https://res.cloudinary.com/finzy/image/upload/v1490882659/default-user-icon-profile_qjsn3w.png';
                    }

                    if (this.result2.lender_info.lender_application_status == 'invested' && this.result2.lender_info.bank_account) {

                        this.router.navigate(['/investordashboard']);

                    } else if (this.result2.lender_info.lender_application_status == 'invested' && !this.result2.lender_info.bank_account) {
                        this.lender_status = 'Your Account is verified  ';
                        this.bankDetails = true;

                    } else if (this.result2.lender_info.lender_application_status == 'ready_for_kyc' || this.result2.lender_info.lender_application_status == 'kyc_in_progress') {
                        this.lender_status = 'Your Account verification is in progress';
                    } else {
                        this.lender_status = 'Your Account is verified ';
                    }
                }
            });
    }

    public openVirtualAccountDescriptionPopup(): void {
        this.dialog.open(VirtualAccountDescriptionPopUpComponent, {width: '700px'});
    }

    public getSubstring(virtualAccountNumber: string, fromIndex: number, toIndex: number): string {
        return virtualAccountNumber.substring(fromIndex, toIndex);
    }
}
